//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    editMode: {
      default:false
    }
  },
  methods: {
    edit() {
      this.$emit("edit");
    },
    save() {
      this.$emit("save");
    },
    cancel() {
        this.$emit("cancel")
    }
  },
};
